import { render } from "./Message.vue?vue&type=template&id=34893964&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=34893964&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34893964"

export default script